// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__53uV7","mainCard":"style_mainCard__SlGMB","mainContainer":"style_mainContainer__dai6m","alertContainer":"style_alertContainer__scg+n"};